import React from 'react';
import LeadsManageCompany from '../components/pages/leadsmanage/Company';
import LeadsManageTeam from '../components/pages/leadsmanage/Team';
import LeadsManagePersonal from '../components/pages/leadsmanage/Personal';
import LeadsManageTest from '../components/pages/leadsmanage/Test';
import Pool from '../components/pages/leadsmanage/LeadsPoolPage';
import ComponentReport from '../components/pages/componentReport/ComponentReportPage';
import OffocialAccounts from '../components/pages/offocialAccounts';
import QwAuth from '../components/pages/qw/auth';
import QwMessageRemind from '../components/pages/qw/messageRemind';
import QwWelcome from '../components/pages/qw/welcome';
import { LeadsDataUpload } from '../components/pages/dataUpload/leadsDataUpload';
import { QwDataUpload } from '../components/pages/dataUpload/qwDataUpload';
import { TotalUploadAnalysis } from '../components/pages/analysisUpload/totalUploadAnalysis';
import { TotalUploadDetail } from '../components/pages/analysisUpload/totalUploadDetail';
import Fans from '../components/pages/wxFansManage';
import Tag from '../components/pages/tag';
import MessageManage from '../components/pages/messageManagement';
import EmployeeManage from '../components/pages/employeemanage/EmployeeManagePage';
import GroupManage from '../components/pages/groupmanage/GroupManagePage';
import RolePrivileManage from '../components/pages/rolePrivilege/RolePrivilegePage';
import Clue from '../components/pages/setting/clue/clueTab';
import Sms from '../components/pages/setting/clue/SmsTab';
import Wechat from '../components/pages/setting/clue/WechatTab';
import Cleaning from '../components/pages/setting/cleaning';
import Recycle from '../components/pages/setting/recycle';
import FiledConvert from '../components/pages/leadsForward/filedConvert';
import ApiForward from '../components/pages/leadsForward/apiForward';
import BindList from '../components/pages/multiAccount/bindListTab';
import BindHistory from '../components/pages/multiAccount/bindHistory';
import AuthList from '../components/pages/multiAccount/authListTab';
import AuthHistory from '../components/pages/multiAccount/authHistory';
import InterfaceSettingPage from '../components/pages/interfaceSetting/index';
import LeadsApiDataPage from '../components/pages/leadsApiManage/LeadsApiDataPage';
import LabelManagePage from '../components/pages/setting/labelManage/labelManagePage';
import CallingManagePage from '../components/pages/leadsmanage/callingManage';

import CustomerList from '../components/pages/qwCustomerList';
import QwEmployeeManage from '../components/pages/qwEmployeeManage';
import QwTeamManage from '../components/pages/qwTeamManage';
import Archive from '../components/pages/qwConversationArchive';
import QwArchiveConfig from '../components/pages/qwArchiveConfig';
import { AnalysisEmployeeChart } from '../components/pages/analysisEmployeeChart';
import LeadsAuth from '../components/pages/setting/authorization';
import StateManage from '../components/pages/setting/stateManage';
import CallSetting from '../components/pages/setting/callSetting';
import Drainage from '../components/pages/qwDrainage';
import DrainageEditor from '../components/pages/qwDrainage/Editor';
import CompanyWx from '../components/pages/personalWx/Company';
import TeamWx from '../components/pages/personalWx/Team';
import PersonalWx from '../components/pages/personalWx/Personal';

const NotFound = () => {
  return (
    <div className="not-found-error">Page not found.</div>
  );
};

const pageMap = {
  '/leads/leadsManage/company': LeadsManageCompany,
  '/leads/leadsManage/team': LeadsManageTeam,
  '/leads/leadsManage/personal': LeadsManagePersonal,
  '/leads/leadsManage/companytestdatas': LeadsManageTest,
  '/leads/pool/leadsPool': Pool,
  '/leads/pool/leadsPool/testdatas': Pool,
  '/leads/calling/callingManage': CallingManagePage,
  '/componentReport/reportList/componentReport': ComponentReport,
  '/fan/wx/company': CompanyWx,
  '/fan/wx/team': TeamWx,
  '/fan/wx/personal': PersonalWx,
  '/fan/official/offocialAccounts': OffocialAccounts,
  '/fan/fans/fansManage': Fans,
  '/fan/fans/tag': Tag,
  '/fan/reply/messageManage': MessageManage,
  '/system/group/employeeManage': EmployeeManage,
  '/system/group/groupManage': GroupManage,
  '/system/permission/rolePrivileManage': RolePrivileManage,
  '/system/leadsManageSetting/clue': Clue,
  '/system/leadsManageSetting/recycle': Recycle,
  '/system/leadsManageSetting/sms': Sms,
  '/system/leadsManageSetting/wechat': Wechat,
  '/system/leadsManageSetting/cleaning': Cleaning,
  '/system/leadsManageSetting/label': LabelManagePage,
  '/system/leadsManageSetting/state': StateManage,
  '/system/leadsManageSetting/call': CallSetting,
  '/system/leadsAuth/authorization': LeadsAuth,
  '/system/leadsForward/Filed': FiledConvert,
  '/system/leadsForward/Api': ApiForward,
  '/system/leadsForward/Api/interfaceSetting': InterfaceSettingPage,
  '/system/leadsForward/Api/leadsApiData': LeadsApiDataPage,
  '/system/multiAccount/bindlist': BindList,
  '/system/multiAccount/bindHistory': BindHistory,
  '/system/multiAccount/authList': AuthList,
  '/system/multiAccount/authHistory': AuthHistory,
  '/qw/setting/auth': QwAuth,
  '/qw/setting/employee': QwEmployeeManage,
  '/qw/setting/team': QwTeamManage,
  '/qw/customer/customerList': CustomerList,
  '/qw/message/welcome': QwWelcome,
  '/qw/message/remind': QwMessageRemind,
  '/qw/conversation/config': QwArchiveConfig,
  '/qw/conversation/archive': Archive,
  '/analysis/leadsData/employee': AnalysisEmployeeChart,
  '/analysis/rule/leads': LeadsDataUpload,
  '/analysis/rule/qw': QwDataUpload,
  '/qw/acquisition/drainage': Drainage,
  '/qw/acquisition/drainage/create': DrainageEditor,
  '/qw/acquisition/drainage/edit/:id': DrainageEditor,
  '/qw/acquisition/drainage/detail/:id': DrainageEditor,
  '/analysis/upload/total': TotalUploadAnalysis,
  '/analysis/upload/detail': TotalUploadDetail,
};

export const fillPageComponent = (routes) => {
  const routesClone = JSON.parse(JSON.stringify(routes));

  const fill = (routeArr) => {
    for (const route of routeArr) {
      if (Array.isArray(route.routes)) fill(route.routes);
      if (!route.component) continue;
      route.component = pageMap[route.path] || NotFound;
    }
  };

  fill(routesClone);

  return routesClone;
};
